import { render, staticRenderFns } from "./StartupInvestmentInfo.vue?vue&type=template&id=491f6bdb&scoped=true&"
import script from "./StartupInvestmentInfo.vue?vue&type=script&lang=js&"
export * from "./StartupInvestmentInfo.vue?vue&type=script&lang=js&"
import style0 from "./StartupInvestmentInfo.vue?vue&type=style&index=0&id=491f6bdb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491f6bdb",
  null
  
)

export default component.exports